(function () {
  function Tongji() {
    this.request =
      "https://api-tongji" +
      (/^(teacher-)?release/.test(location.host)
        ? "-release"
        : /^(teacher-)?test/.test(location.host)
        ? "-test"
        : "") +
      ".dingdingkaike.com/Visit/homeVisitRecord";
    // this.request =
    //   'https://api-tongji-test.dingdingkaike.com/Visit/homeVisitRecord'

    this.init();
  }

  Tongji.prototype.init = function () {
    this.option = Object.assign(
      {},
      {
        id: "",
        d_from: "",
        d_plan: "",
        d_unit: "",
        d_keyword: "",
        visitor_code: this.getVisitorCode(),
        device: this.getDevice() ? 2 : 1,
        previous_page_url: this.getPreviousPageUrl(),
        current_page_url: location.href,
      },
      this.urlParameter
    );

    // console.log(this.option)

    this.beforeunload();
    this.send();
  };

  // 获取唯一标识
  Tongji.prototype.getVisitorCode = function () {
    var uniq;
    var cookieName = "dk_visitorCode";
    var oldVal = this.cookie._get(cookieName);

    if (oldVal) {
      uniq = oldVal;
    } else {
      uniq = "ddkk_" + Date.now() + "_" + parseInt(Math.random() * 1e6);
      this.cookie._set(cookieName, uniq);
    }

    return uniq;
  };

  // 获取设备型号 1 PC 2 手机
  Tongji.prototype.getDevice = function () {
    return /Android|iPhone|SymbianOS|Windows Phone|iPod|iPad/i.test(
      navigator.userAgent
    );
  };

  // 获取前一个文档的url
  Tongji.prototype.getPreviousPageUrl = function () {
    return document.referrer;
  };

  // 获取地址栏url参数
  Tongji.prototype.urlParameter = (function () {
    var url = location.href.split("?")[1];
    var urlData = {};
    try {
      if (url) {
        url = url.split("#")[0];
        var temp = url.split("&");
        for (var i = 0; i < temp.length; i++) {
          var t = temp[i].split("=");
          urlData[t[0]] = decodeURI(t[1]);
        }
      }
    } catch (e) {}
    return urlData;
  })();

  // cookie
  Tongji.prototype.cookie = {
    _set: function (name, value) {
      var Days = 365;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie =
        name + "=" + value + ";expires=" + exp.toGMTString() + ";path=/";
    },
    _get: function (name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

      if ((arr = document.cookie.match(reg))) return arr[2];
      else return null;
    },
  };

  // 获取表单格式的数据
  Tongji.prototype.getFormData = function () {
    var options = this.option;

    var fd = new FormData();
    for (var key in options) {
      var item = options[key];
      fd.append(key, item);
    }

    return fd;
  };

  // 页面离开处理函数
  Tongji.prototype.beforeunload = function () {
    var handler = ["pagehide", "unload", "beforeunload"];
    handler.forEach((fn) => {
      window.addEventListener(fn, () => {
        if (this.destoryed) return;
        this.destoryed = true;
        this.send();
      });
    });
  };

  // 发送请求
  Tongji.prototype.send = function () {
    if (!this.option.id) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", this.request);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          try {
            this.option.id = JSON.parse(xhr.responseText).data;
            window.dk_queryId = this.option.id || "";
          } catch (e) {}
        }
      };
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify(this.option));
    } else {
      navigator.sendBeacon(this.request, this.getFormData());
    }
  };

  new Tongji();
})();
